import React, { useEffect, useState } from 'react';
import { CountryCode } from '@dayetopia/types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import AddToCart from '@components/shared/AddToCart';
import Button from '@components/shared/Button';
import Colors from '@components/shared/Colors';
import { CartItem, ProductCode } from '@contracts';
import { useCountry } from '@hooks/useCountry';
import useNavigate from '@utils/useNavigate';

interface HeroAuxButtonProps {
  productCode: string;
  generateCartItem: () => CartItem;
  onAddToCartClick: () => void;
}

const HeroAuxButton: React.FC<HeroAuxButtonProps> = ({ productCode, generateCartItem, onAddToCartClick }) => {
  const { t } = useTranslation();
  const { navigateWrapper } = useNavigate();
  const [showBuyButton, setShowBuyButton] = useState(false);
  const { country } = useCountry();

  useEffect(() => {
    if (!productCode || (country !== CountryCode.GB && productCode === ProductCode.VMSEssential)) {
      setShowBuyButton(false);
    } else {
      setShowBuyButton(true);
    }
  }, [country, productCode]);

  if (productCode === 'ppc') {
    return (
      <Button backgroundColor={Colors.paleGold} buttonTextColor={Colors.navyBlue} onClick={() => navigateWrapper('/ppc-questionnaire/')}>
        {t('components.get-started')}
      </Button>
    );
  }

  if (showBuyButton) {
    return (
      <AddToCart
        id={`quick_buy_${productCode}`}
        cartItem={generateCartItem()}
        backgroundColor={Colors.paleGold}
        buttonTextColor={Colors.navyBlue}
        buttonText={t('components.quick-buy')}
        callback={onAddToCartClick}
      />
    );
  }

  return null;
};

export default HeroAuxButton;
